import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';

import { Profile } from '@/components/Settings/Profile';
import { SettingsPageLayout } from '@/components/Settings/SettingsPageLayout';
import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/$organizationName/settings/account')({
  component: Account,
});

function Account() {
  const { organizationDisplayName } = useUser();

  useEffect(() => {
    document.title = `${organizationDisplayName || 'Driver'} - Account`;
  }, [organizationDisplayName]);

  return (
    <SettingsPageLayout title="Account" subTitle="Manage your account">
      <Profile />

      {/* We've decided to disable Dark Mode for now */}
      {/* <ThemeSelector /> */}
    </SettingsPageLayout>
  );
}
